import { PageHeader } from '@my/ui';
import { ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';

/**
 * Walk-around check detail / capture form — placeholder. The `:id` param is
 * absent for the "new" route and present when viewing/editing an existing
 * check. Wire the real inspection form in once the Safety API lands.
 */
export function CheckDetailPage() {
  const { t } = useTranslation('checks');
  const { id } = useParams();
  const isNew = !id;

  return (
    <div className="mx-auto max-w-5xl px-6 py-8">
      <Link
        to="/checks"
        className="mb-3 inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-700"
      >
        <ArrowLeft className="h-4 w-4" />
        {t('detail.backToList')}
      </Link>
      <PageHeader
        title={isNew ? t('detail.newTitle') : t('detail.title')}
        description={t('detail.description')}
      />
      <section className="mt-6 rounded-lg border border-dashed border-slate-300 bg-white p-10 text-center shadow-sm">
        <p className="text-sm text-slate-500">{t('detail.comingSoon')}</p>
      </section>
    </div>
  );
}
